module.exports = __webpack_public_path__ + "static/media/bg.3910e9ed.png";